module.exports = __webpack_public_path__ + "9929390674007f20227ef5ee6fab53ff.svg";